<template>
  <div>
    <div class="proxima--font">
      <ManageBaseTableHeader :title="$route.name" :is-searchable="false" />
      <WithMenu v-slot="{ sections, loading }">
        <transition name="fade" mode="out-in">
          <v-row v-if="loading">
            <v-col cols="12" sm="10" lg="8" xl="6" class="mx-auto text-center">
              <v-progress-circular
                indeterminate
                size="15"
                width="2"
                color="amber lighten-2"
                class="mx-auto"
              />
              <h3 class="grey--text text--darken-2 text-h6"
                >Loading the menu...</h3
              >
            </v-col>
          </v-row>
          <ManageMenuOrder v-else :sections="sections" />
        </transition>
      </WithMenu>
    </div>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor"
      ><h2>{{ snackText }}</h2></v-snackbar
    >
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import WithMenu from '@/components/DataProviders/WithMenu'
import ManageBaseTableHeader from '@/components/ManageBaseTableHeader'
import ManageMenuOrder from '@/components/ManageMenuOrder'

export default {
  name: 'ManageIndexView',
  components: {
    WithMenu,
    ManageBaseTableHeader,
    ManageMenuOrder,
  },
  meta() {
    return { title: `Reorder Menu | Minimart` }
  },
  data() {
    return {
      snack: false,
      snackColor: '',
      snackText: '',
    }
  },
  created() {
    this.fetchShopById()
  },
  methods: {
    ...mapActions('shop', ['fetchShopById']),
    // Dialog actions for provide/inject
    close() {
      this.showSnack('info', 'Closed without saving.')
    },
    cancel() {
      this.showSnack('warn', 'Canceled edit.')
    },
    open() {
      this.showSnack('info', 'Press Enter to Save.')
    },
    saved() {
      this.showSnack('success', 'Saved')
    },
    showSnack(color, text) {
      this.snack = true
      this.snackColor = color
      this.snackText = text
    },
  }, // methods

  provide() {
    return {
      close: this.close,
      cancel: this.cancel,
      open: this.open,
      saved: this.saved,
    }
  },
  computed: {
    ...mapGetters('shop', [
      'getShopTitle',
      'getDeliverySlots',
      'getPickupSlots',
      'getFulfillmentOptions',
      'getFulfillmentSlotsList',
    ]),
    ...mapFields('admin', ['tableItems']),
    ...mapFields('admin', {
      sortBy: 'tableMeta.sortBy',
    }),
    basePath() {
      let uri_path = this.Model.uri_path ?? this.Model.entity
      return `/settings/${uri_path}`
    }, // basePath
    modelName() {
      return this.Model.namePlural
    },
  },
  watch: {
    tableItems(tableItems) {
      if (tableItems.length && this.$route.params.id) {
        let item = tableItems.find((i) => i.id == this.$route.params.id)
        if (item) {
          this.openEditDialog(null, { item, headers: this.headers })
        }
      }
    },
  }, // watch
}
</script>

<style lang="scss">
.mm-base-table.v-data-table {
  th {
    font-size: 0.9rem;
    font-weight: 700;
    justify-content: baseline;
  }
  tr td {
    border-left: thin solid rgba(0, 0, 0, 0.12);
    &:last-child {
      border-right: thin solid rgba(0, 0, 0, 0.12);
    }
  }
  > .v-data-table__wrapper > table > tbody > tr > td {
    padding-left: 8px;
    padding-right: 8px;
  }
}

.handle {
  cursor: move !important;
  cursor: -webkit-grab !important;
}
</style>
